import {Stack} from '@mui/material'
import React, {useEffect, useState} from 'react'
import TitlePage from '../customTable/TitlePage'
import {useTranslation} from 'react-i18next'
import Cards from './Cards'
import Msg from './Msg'
import MainBtn from '../customTable/MainBtn'
import {useNavigate} from 'react-router-dom'
import PackagesApi from '../../Api/Packages'
import NoNetWork from '../customTable/NoNetWork'

export default function Subscriptions() {
  const {t} = useTranslation()

  const bannerInfo = {
    title: t('subscriptions'),
    home: t('home'),
    linkHome: '/',
  }
  const [open, setOpen] = React.useState(false)
  const navagiate = useNavigate()
  useEffect(() => {
    setTimeout(() => {
      // setOpen(true)
    }, 5000)
  }, [])
  const [isLoading, setIsLoading] = useState(false)
  const [data, setData] = useState<any>({})
  const getData = () => {
    PackagesApi.getInfo((res: any) => {
      setData(res.data)
    }, setIsLoading)
  }
  useEffect(() => {
    getData()
  }, [])
  return (
    <NoNetWork>
      <Stack>
        <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
          <TitlePage info={bannerInfo} />
          <MainBtn
            handelSubmit={() => {
              navagiate('/subscriptions-date')
            }}
            width='auto'
            text='subscriptionHistory'
          />
        </Stack>
        <Cards setData={setData} data={data} />
        <Msg setOpen={setOpen} open={open} />
      </Stack>
    </NoNetWork>
  )
}
